// extracted by mini-css-extract-plugin
export default {"container":"hotelCardMapTitleBlock-module__container__zkDhu","buttonsBlock":"hotelCardMapTitleBlock-module__buttonsBlock__FgJr-"};